export const parseLinksToAnchorTags = (text: string) => {
  const linkRegex = /((https?:\/\/|www\.)[^\s<>]+|(?:\b[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s<>]*)?))/g; // - find all links in the text doesn't need https - https://regex101.com/r/RirsCn/1

  return text.replace(linkRegex, (url) => {
    let formattedUrl = url;
    if (!/^https?:\/\//.test(formattedUrl)) {
      formattedUrl = `https://${formattedUrl}`;
    }

    return `<a href="${formattedUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
};
